import { ITextfieldValueDisp } from "./interfaces/ITextfieldValueDisp";
import { AValueComponent } from "./AValueComponent";
import { ValueChangerController } from "./ValueChangerController";
import {KeyboardEvent} from "@goodgamestudios/createjs-utilities";


export class InputTextfieldValueComponent extends AValueComponent {
    protected _textfieldContainer: ITextfieldValueDisp;

    constructor(parent: ValueChangerController, p_minValue: number, p_maxValue: number, textFieldContainer: ITextfieldValueDisp) {
        super(parent, p_minValue, p_maxValue);
        this._textfieldContainer = textFieldContainer;
        this._textfieldContainer.getTextfield().addEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onPlayerInput));
    }

    private onPlayerInput(event: KeyboardEvent): void {
        let input: string = this._textfieldContainer.getTextfield().text;
        if (event.code == "ArrowRight" || event.code == "ArrowLeft") {
            return;
        }

        if (this.validateInput(input)) {
            let value: number = parseInt(input);
            this.dispatchUpdateByUserSignal(value);
        }
    }

    private validateInput(input: string): boolean {
        let num: number;
        try {
            num = parseInt(input);
        }
        catch (e) {
            return false;
        }

        return !isNaN(num);
    }

    public updateValue(value: number): void {
        super.updateValue(value);
        this._textfieldContainer.getTextfield().text = value.toString();
        this._textfieldContainer.getTextfield().setSelection(this._textfieldContainer.getTextfield().length, this._textfieldContainer.getTextfield().length);
    }

    public dispose(): void {
        super.dispose();
        this._textfieldContainer.getTextfield().removeEventListener(KeyboardEvent.KEY_UP, this.bindFunction(this.onPlayerInput));
    }
}
